$(document).ready(function(){
  // #upsell_slider on theme.js 5874 line and 5826
  $(document).on('click','.mini-cart button.upsell_btn',function(){
    console.log('hh');
    $(this).addClass('loading');
    var id = $(this).data('pro-id');
    console.log(id);
    var arrPdp = [];
    if(id != ''){    
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: id
      },
      dataType: 'json', 
      success: function (data) { 
        $('.mini-cart button.upsell_btn').removeClass('loading');
        // document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: data
        }));  
        
       } 
      });
    }
  });  
  if($('body').hasClass('template-product')){
     $(document).find('.template-product #upsell_slider').slick({
          infinite: false,
          slidesToShow: 1.4,
          slidesToScroll: 1,
          arrows:false
        });
    
   $(document).on('click','.product__info button.upsell_btn',function(){
    console.log('pro');
     $(this).addClass('loading');
    var id = $(this).data('pro-id');
    console.log(id);
    var arrPdp = [];
    if(id != ''){    
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: id
      },
      dataType: 'json', 
      success: function (data) { 
        
        // document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: data
        })); 
        var cartDrawerButtonSelector = "a.header__icon-wrapper[aria-controls='mini-cart']";
        var cartDrawerButton = document.querySelector(cartDrawerButtonSelector);
        setTimeout(function() {
        cartDrawerButton.click();
        $('.product__info button.upsell_btn').removeClass('loading');
        }, 1000);
       } 
      });
    }
  });
  }


  // $('.shopify-section--product-recommendations .product-list__inner').slick({
  //   infinite: false,
  //   dots: true,
  //   arrows: false,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //   {
  //     breakpoint: 1200,
  //     settings: {
  //       slidesToShow: 2.4,
  //       slidesToScroll: 1
  //     }
  //   },
  //   {
  //     breakpoint: 768,
  //     settings: {
  //       slidesToShow: 1.4,
  //       slidesToScroll: 1
  //     }
  //   }
  // ]
  // });
  
});